export * from './my-module.module';
export * from './components/my-component';
export * from './providers/my-provider';
